import {
    deleteClientLoading,
    deleteClientRequest,
    deleteClientSuccess,
    deleteClientReject,
    deleteClientReset
} from "../../actions/client/delete";

export const deleteClient = (formData) => async (dispatch, getState) => {
    dispatch(deleteClientLoading());
    try {
        const { data } = await deleteClientRequest(formData, getState);
        dispatch(deleteClientSuccess(data))
    } catch (error) {
        dispatch(deleteClientReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteClientReset()) }, 3000);
    }
    return Promise.resolve();
};